import { render } from "./CouponIcon.vue?vue&type=template&id=4a61a636"
const script = {}

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__